<template>
  <v-app>
    <div
      v-if="!isIframePreview"
      :style="$store.getters['ui/folder.externalElement'].id?'cursor:grabbing':''"
      @mousemove="updateCoordinates"
      @mouseup="outsideClickHandler()"
    >
      <m-header />
      <v-content>
        <v-row no-gutters>
          <v-col
            v-if="userRoles"
            id="mySidenav"
            cols="auto"
          >
            <left-menu-bar />
          </v-col>
          <v-col
            v-if="$store.state.ui.folder.type"
            cols="auto"
            :style="{position:($vuetify.breakpoint.smAndDown ? 'inherit': 'relative')}"
          >
            <v-tooltip
              left
              bottom
              nudge-right="52"
              nudge-top="7"
              :disabled="$vuetify.breakpoint.smAndDown"
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  v-if="!$vuetify.breakpoint.smAndDown"
                  size="20"
                  class="folder-trigger"
                  color="white"
                  style="outline:none"
                  :class="($vuetify.breakpoint.smAndDown ? 'is-mobile' : '')"
                  v-on="on"
                  @click="toggleDrawer"
                >
                  {{ !$store.getters['ui/folder'].show ? 'mdi-folder-open' : 'mdi-close' }}
                </v-icon>
              </template>
              <span>{{ !$store.getters['ui/folder'].show ? 'Open Folders' : 'Close Folders' }}</span>
            </v-tooltip>
            <folder-tree />
          </v-col>
          <v-col
            id="main-content-wrapper"
            class="vertical-stretch"
            style="position:relative;"
            @scroll="scrollHandler"
          >
            <snack-bar />
            <loading-spinner />

            <router-view
              ref="childComponentRef"
              v-resize="onResize"
            />
            <v-navigation-drawer
              v-if="$store.state.ui.drawer.right.show"
              v-model="$store.state.ui.drawer.right.show"
              fixed
              temporary
              :permanent="$store.state.ui.drawer.right.permanent"
              right
              :width="$store.state.ui.drawer.right.width || '500px'"
              class="header-stretch"
            >
              <component :is="$store.state.ui.drawer.right.component" />
            </v-navigation-drawer>
          </v-col>
        </v-row>
        <v-row
          v-if="$store.state.ui.chat"
          class="footer-chat"
          :class="!($store.state.ui.loader.iframe) && chat_visible ? '' : 'footer-chat-hide'"
        >
          <v-col
            class="custom-chat-widget pa-4"
            v-bind="dialPadConfig"
          >
            <v-icon
              class="cross-icon"
              @click.stop="closeChat()"
            >
              clear
            </v-icon>
            <v-img
              width="25"
              justify="center"
              src="@/assets/chat.svg"
            />
          </v-col>
        </v-row>
        <div
          v-if="$store.getters['ui/folder.externalElement'].id"
          id="folder-tooltip"
          class="elevation-8"
        >
          <v-icon>mdi-folders</v-icon>
          <span>Move {{ $store.getters['ui/folder.externalElement'].id.length > 1 ? $store.getters['ui/folder.externalElement'].id.length : '' }}
            {{ $store.getters['ui/folder.externalElement'].type.replace('/',' ').replaceAll('_',' ') | wordUpperCase }}{{ $store.getters['ui/folder.externalElement'].id.length > 1 ?
              's ':' ' + $store.getters['ui/folder.externalElement'].name }}</span>
        </div>
        <div
          v-if="$store.state.ui.newUpdateAvailable"
          id="new-update-available"
          class="elevation-4"
        >
          <div class="d-flex flex-column pa-4">
            <h2 class="subtitle-1 ">
              New version of Maropost is available.
            </h2>
            <p class="mb-7 grey--text text--darken-2 body-2">
              Update now to get the latest version.
            </p>
            <div class="text-right">
              <v-btn
                text
                class="font-weight-bold mr-5 subtitle-2"
                @click="update(false)"
              >
                REMIND ME LATER
              </v-btn>
              <v-btn
                outlined
                @click="update(true)"
              >
                UPDATE
              </v-btn>
            </div>
          </div>
        </div>
      </v-content>
    </div>
    <div v-if="isIframePreview">
      <v-content>
        <v-row no-gutters>
           <v-col
            style="position:relative;"
          >
            <snack-bar />
            <loading-spinner />

            <router-view
              ref="childComponentRef"
              :key="$route.path"
              v-resize="onResize"
            />
           </v-col>
        </v-row>
      </v-content>
    </div>
  </v-app>
</template>

<script>
  import LoadingSpinner from '@/components/LoadingSpinner'
  import FolderTree from '@/components/FolderTree'
  import LeftMenuBar from '@/components/LeftMenuBar'
  import SnackBar from '@/components/ui/SnackBar'
  import smsListsDrawer from '@/views/drawers/smsListsDrawer'
  import ReportsDrawer from '@/views/drawers/ReportsDrawer'
  import ContactTagsDrawer from '@/views/drawers/ContactTagsDrawer'
  import ListCartDrawer from '@/views/drawers/ListCartDrawer'
  import ChangePasswordDrawer from '@/views/drawers/ChangePasswordDrawer'
  import CreateUserDrawer from '@/views/drawers/CreateUserDrawer'
  import ApikeyDrawer from '@/views/drawers/ApikeyDrawer'
  import { mapActions, mapGetters } from 'vuex'
  import CustomFieldsDrawer from '@/views/drawers/CustomFieldsDrawer'
  import SftpChangePasswordDrawer from '@/views/drawers/SftpChangePasswordDrawer'
  import ShopifyDetailDrawer from '@/views/drawers/ShopifyDetailDrawer'
  import NetoIntegrationDrawer from '@/views/drawers/NetoIntegrationDrawer'
  import NetoDetailDrawer from '@/views/drawers/NetoDetailDrawer'
  import KeapIntegrationDrawer from '@/views/integrations/keap/KeapIntegrationDrawer.vue'
  import KeapDetailDrawer from '@/views/integrations/keap/KeapDetailDrawer.vue'
  import ZapierIntegrationDrawer from '@/views/drawers/ZapierIntegrationDrawer'
  import ProductFeedDrawer from '@/views/drawers/ProductFeedDrawer'
  import ProductDrawer from '@/views/drawers/ProductDrawer'
  import CampaignDetailsDrawer from '@/views/drawers/CampaignDetailsDrawer'
  import CartsIntegrationDrawer from '@/views/drawers/CartsIntegrationDrawer'
  import CartsDetailDrawer from '@/views/drawers/CartsDetailDrawer'
  import SalesforceDetailDrawer from '@/views/drawers/SalesforceDetailDrawer'
  import RetailExpressDetailDrawer from '@/views/drawers/RetailExpressDetailDrawer'
  import BrandsListDrawer from '@/views/drawers/BrandsListDrawer'
  import ClickbankDetailDrawer from '@/views/drawers/ClickBankDetailDrawer'
  import ChooseImageDrawer from '@/components/ui/ImageLibrary/ChooseImageDrawer.vue'
  import segmentAiDrawer from '@/views/segments/nextGen/AIDrawer/init.vue'
  import AbandonedCartApiDrawer from '@/views/drawers/AbandonedCartApiDrawer'
  import ModifyPermissionsDrawer from '@/views/drawers/ModifyPermissionsDrawer'
  import { DashboardComponents } from '@core/components'
  import PreviewDrawer from '@/views/drawers/PreviewDrawer.vue'
  import ERFMGroupDrawer from '@/views/drawers/ERFMGroupDrawer'
  import ERFMSettingsDrawer from '@/views/drawers/ERFMSettingsDrawer'
  import constants from '@/constants'
  import { getSplitKey } from '@/splitClient';

  export default {

    name: 'App',
    components: {
      ...DashboardComponents,
      LeftMenuBar,
      FolderTree,
      ListsDrawer : () => getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import('@/views/drawers/UIDListsDrawer'): import('@/views/drawers/ListsDrawer'),
      smsListsDrawer,
      CustomFieldsDrawer,
      ContactTagsDrawer,
      SnackBar,
      ContactInfoDrawer: () => getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import('@/views/drawers/UIDContactInfoDrawer'): import('@/views/drawers/ContactInfoDrawer'),
      AutomatedFTPImportsDrawer: () => getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import('@/views/drawers/UIDAutomatedFTPImportsDrawer'): import('@/views/drawers/AutomatedFTPImportsDrawer'),
      ListCartDrawer,
      LoadingSpinner,
      ReportsDrawer,
      ListDetailsDrawer : () => getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import('@/views/drawers/UIDListDetailsDrawer'): import('@/views/drawers/ListDetailsDrawer'),
      KeywordsDrawer : () => getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import('@/views/drawers/UIDKeywordsDrawer'): import('@/views/drawers/KeywordsDrawer'),
      ShopifyIntegrationDrawer: () => getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import('@/views/drawers/UIDShopifyIntegrationDrawer'): import('@/views/drawers/ShopifyIntegrationDrawer'),
      ShopifyDetailDrawer,
      ChangePasswordDrawer,
      SftpChangePasswordDrawer,
      CreateUserDrawer,
      ApikeyDrawer,
      NetoIntegrationDrawer,
      NetoDetailDrawer,
      KeapIntegrationDrawer,
      KeapDetailDrawer,
      ZapierIntegrationDrawer,
      ProductFeedDrawer,
      ProductDrawer,
      KeapConnectionDrawer : () => getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import('@/views/integrations/keap/UIDKeapConnectionDrawer.vue'): import('@/views/integrations/keap/KeapConnectionDrawer.vue'),
      CartsIntegrationDrawer,
      CartsDetailDrawer,
      CampaignDetailsDrawer,
      SalesforceIntegrationDrawer : () => getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import('@/views/drawers/UIDSalesforceIntegrationDrawer'): import('@/views/drawers/SalesforceIntegrationDrawer'),
      SalesforceDetailDrawer,
      RetailExpressIntegrationDrawer : () => getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import('@/views/drawers/UIDRetailExpressIntegrationDrawer'): import('@/views/drawers/RetailExpressIntegrationDrawer'),
      RetailExpressDetailDrawer,
      BrandsListDrawer,
      ClickBankIntegrationDrawer : () => getSplitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import('@/views/drawers/UIDClickBankIntegrationDrawer'): import('@/views/drawers/ClickBankIntegrationDrawer'),
      ClickbankDetailDrawer,
      ChooseImageDrawer,
      segmentAiDrawer,
      AbandonedCartApiDrawer,
      ModifyPermissionsDrawer,
      PreviewDrawer,
      ERFMGroupDrawer,
      ERFMSettingsDrawer
    },
    data () {
      return {
        folderDrawer: true,
        railsData: {},
        page: 1,
        perPage: 10,
        chat_visible: true,
        timeout_obj: null,
        constants:constants
      }
    },
    computed: {
      ...mapGetters({
        allData: 'allData',
        account: 'auth/account',
        userAccess: 'auth/userAccess',
        userData: 'auth/userdata',
      }),
      isIframePreview(){
        let app = document.getElementById('app');
        if(app){
          if(app.ownerDocument.URL.includes('/content_templates') && app.ownerDocument.URL.includes('/preview')){
            return true;
          }else{
            return false;
          }
        }
        return false
      },
      userRoles() {
        return (this.account.current && this.account.current.enable_marketing && this.userAccess.haveMarketingRole)
      },
      dialPadConfig () {
        const { email, first_name, last_name, phone } = this.userData
        return {
          'id': 'kpd_koopidtag',
          'data-kpdtag': 'Welcome_108968',
          'data-kpdprovemail': '5841433476481024@maropost.com',
          'data-kpdguest': true,
          'data-kpdembedded': true,
          'data-kpdwfvars': `customer.session.custname=${first_name} ${last_name},customer.session.custemail=${email},customer.session.custphone=${phone}`
        }
      }
    },
     watch: {
      '$store.state.sharedEvent' (){
        if(this.$store.state.sharedEvent == 'reload'){
          setTimeout(() => {
            if(this.$store.state.reloadTab)
              location.reload();
          }, 2000);
        }
      }
    },
    mounted () {
      setTimeout(()=>{
        this.$store.commit('reloadTab',true)
        this.$store.commit('sharedEvent','')
        this.initDialPadChatService();
      },1000)
    },
    methods: {
      /**
       * Injected Dialpad Chat script and Initializes the embedded chat application
       */
      initDialPadChatService () {
        const script = document.createElement('script');
        const link = document.createElement('link');
        script.setAttribute('src', 'https://us-east.dx.dialpad.com/static/common/js/koopid-embed.min.js');
        document.body.appendChild(script);

        script.onload = () => {
          kpde.server = "https://us-east.dx.dialpad.com";
          kpde.initialize();
        };

        link.href = 'https://us-east.dx.dialpad.com/static/common/css/koopid.css'
        link.rel = 'stylesheet'
        document.head.appendChild(link);
      },

      /* * onResize calls everytime when its child component loads.
       * it checks if child components have any v-data-table and table have refs tableRef
       * if refs exists but table not intialize yet then onResize called after every 500 ms
       * it finds the "type=dateTime" coloumns in refs header
       * @output: it update the width of datetime coloumn according to screen width
       */

      onResize () {
        if (!this.$refs.childComponentRef.$refs.tableRef) return

        const tableWidth = this.$refs.childComponentRef.$refs.tableRef.$el.clientWidth
        if (tableWidth === 0) {
          setTimeout(() => {
            this.onResize()
          }, 500)
          return
        }
        let totalColumnWidth = 0
        let totalDateTimeFields = 0
        this.$refs.childComponentRef.headers.forEach(element => {
          if (element.width && element.type !== 'dateTime') {
            if (element.width.includes('px')) { totalColumnWidth = totalColumnWidth + parseInt(element.width.replace('px', '')) }
            if (element.width.includes('%')) {
              const widthPercentage = parseInt(element.width.replace('%', ''))
              totalColumnWidth = totalColumnWidth + ((tableWidth * widthPercentage) / 100)
            }
          }
          if (element.type === 'dateTime') { totalDateTimeFields++ }
        })
        
        /*  * totalColumnWidth is total width of columns in headers which have widths
            * totalDateTimeFields is the number of columns which have type dateTime
            * tableWidth is the table width according to screen size
            * if condition calculates date can come in 1 line or not
        */
        if (totalColumnWidth + (this.$constants.indexPageWidth.dateMaximumWidth * totalDateTimeFields) 
            + this.$constants.indexPageWidth.nameMinimumWidth < tableWidth) 
            { 
              this.resizeDateColumn(this.$constants.indexPageWidth.dateMaximumWidth) 
            }
        else 
          { 
            this.resizeDateColumn(this.$constants.indexPageWidth.dateMinimumWidth) 
          }
      },
      resizeDateColumn (width) {
        const tableHeaders = [...this.$refs.childComponentRef.headers]
        tableHeaders.forEach(element => {
          if (element.type === 'dateTime') { element.width = width + 'px' }
        })
        this.$refs.childComponentRef.headers = [...tableHeaders]
      },
      closeChat () {
        this.$store.commit('ui/chat', false)
      },
      update (now) {
        if (now) {
          location.reload()
        } else {
          // remind later after 3 hours
          setTimeout(() => {
            this.$store.commit('ui/updateAvailable', true)
          }, 1000 * 60 * 60 * 3)
        }
        this.$store.commit('ui/updateAvailable', false)
      },
      scrollHandler () {
        if (this.$store.getters['ui/chat'] === false) return
        this.chat_visible = false
        const THIS = this
        if (this.timeout_obj !== null) {
          clearTimeout(this.timeout_obj)
        }
        this.timeout_obj = setTimeout(() => {
          THIS.chat_visible = true
        }, 2000)
      },
      outsideClickHandler () {
        setTimeout(() => { this.$store.commit('ui/folder.externalElement', { id: '', type: undefined }) }, 100)
      },
      updateCoordinates (event) {
        if (this.$store.getters['ui/folder.externalElement'].id) {
          document.getElementById('folder-tooltip').style.left = event.pageX + 6 + 'px'
          document.getElementById('folder-tooltip').style.top = event.pageY + 16 + 'px'
        }
      },
      toggleDrawer () {
        this.$store.commit('ui/folder.show')
      },
      ...mapActions(['fetchData']),
    },
  }
</script>
<style lang="scss">
  @import "@/styles/global.scss";
</style>
<style lang="scss">
#new-update-available{
  position: absolute;
  bottom: 49px;
  border-radius: 4px;
  left: 21px;
  border: 1px solid #D6DDE0;
  z-index: 9999;
  background:white;
  border-top: 5px solid #03B6FC;
  animation-name: slideInUp;
  animation-duration: .5s;
}
@keyframes slideInUp {
  0%   {bottom: -20px;}
  100% {bottom: 49px;}
}
#folder-tooltip{
  position: fixed;
  top: -100px;
  color:black;
  border-radius: 3px;
  left: 0;
  padding: 20px;
  z-index: 9999;
  background:white;
}
  .folder-trigger{
    position: absolute;
    left:100%;
    z-index:1;
    top:45px;
    padding:2px;
    border-radius:0 5px 5px 0;
    background:#A0A3AA
  }
  .folder-trigger.is-mobile{
    left:0;
  }
  $primary-font-size: 13px !important;
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active  {
    box-shadow: 0 0 0 30px white inset !important;
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
  .vertical-stretch {
    height: calc(100vh - 64px) !important;
    overflow: auto;
    overflow-x: hidden;
    background-color:rgb(250,250,250);
  }
  .v-application, .primary--font {
    font-family: 'Roboto', sans-serif !important;
  }
  .seconday--font, h1, h2, h3, h4, h5, h6, .v-btn{
    font-family: 'Montserrat', sans-serif !important;
  }
  body {
    font-size: 16px;
    letter-spacing: 0.5px;
  }
  .font-weight-600 {
    font-weight: 600 !important;
  }
  .v-btn--text {
    font-weight: 600 !important;
    letter-spacing: 0.55px;
    font-size:$primary-font-size;
  }
  .v-btn {
    font-weight: bold;
  }
  .v-application .mp-secondary--text {
    color: #4C5463 !important;
    caret-color: #4C5463 !important;
  }
  .footer-chat {
    position: fixed;
    bottom: 20px;
    right: 35px;
    animation: 1s linear chat-widget;
    cursor: pointer;
    transition: all 0.5s;
    z-index: 1;
  }
  .footer-chat-hide {
    bottom: -70px !important;
    opacity:0;
  }
  .custom-chat-widget {
    background-color: #03B6FC;
    border-radius:5px;
    .cross-icon {
    position: absolute;
    top: -15px;
    right: -8px;
    background-color: grey;
    color: #fff !important;
    border-radius: 50%;
    font-size: 16px;
    padding: 5px;
    &:focus{
      outline: none !important;
    }
  }
  }
    h1, h2, h3, h4, h5, h6 {
    font-weight: 600 !important;
  }
  @keyframes chat-widget {
    0%  {bottom: 0px;}
    100% {bottom: 20px;}
  }
/** dashboard filter dropdown css for all widget ***/
.widgetheading{
  font-weight: 600 !important;
  color: #1E2533;
}
.fontsize25px{
  font-size:25px;
  color: rgba(0,0,0,0.54);
}
.widgetselect-box {
  .v-overflow-btn .v-input__control::before{
    height: 0px !important;
  }
  .v-btn__content{
    text-transform: capitalize;
  }
  .v-overflow-btn {
    height:32.22px;
  }
  .v-input__control{
    height:inherit;
  }
  .v-select > .v-input__control > .v-input__slot{
    min-height:32px;
  }
  .v-text-field .v-input__append-inner, .v-input__prepend-inner{
    margin-top:3px !important;
    border-left:0px !important;
  }
  .v-overflow-btn .v-select__slot{
    height: inherit;
  }
}
.v-menu__content .v-list{
  padding: 0;
}
#mySidenav + div .theme--light.v-navigation-drawer:not(.between-filter-navigation)  {
    border-right: 3px solid #A0A3AA !important;
}

.header-stretch {
  height: calc(100% - 64px) !important;
  top: 64px !important;
}.header-stretch {
  height: calc(100% - 64px) !important;
  top: 64px !important;
}
.v-tooltip__content{
      max-width: 600px;
    overflow-wrap: break-word;
}
.no-hyperlink a {
      text-decoration: none;
}
  .text-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  }
  .rotate-hover{
    transition:transform .5s;
      &:hover{
        transform: rotate(90deg);
      }
  }
  .email-camp {
  a {
    text-decoration: none;
  }
}
 .email-camp .v-data-table table {
      tbody tr {
        position: relative;
        td .v-data-table__mobile-row__cell {
           max-width:200px;
          }
        }
      thead th:nth-child(2) {
         padding:0px;
         span{
           margin-left:-8px}
       }
 }
  @media screen and (max-width: 500px) {
      .text-ellipsis {
            max-width: 170px;
      }
  }
  /* Merged */
  #report-create-stepper {
.error--text {
  color: #B00020 !important;
  caret-color: #B00020 !important;
}
label.v-label.v-label--active {
  padding-left: 2px !important;
  padding-right: 6px !important;
}
.custom-selectbox .v-select__selections {
  overflow: auto;
  padding: 10px 0px 10px 0px;
  max-height: 100px;
}
.v-stepper__step--active {
    margin: 0 4px 0 4px;
}
.v-stepper__step__step {
  font-size: 14px !important;
}
.v-text-field--outlined .theme--light.v-label {
  background-color: #FAFAFA;
}
.v-stepper__step {
  color: #006BAF
}
.v-stepper__step--active {
  position: relative;
}
.v-stepper__step--active::after {
  content: '';
  position: absolute;
  height: 34px;
  width: 34px;
  border:2px solid #006BAF;
  border-radius:50%;
  top: 19px;
}
.v-stepper--alt-labels .v-stepper__step {
  flex-basis: auto;
}
.theme--light.v-stepper {
  background: #fafafa;
}
.v-stepper, .v-stepper__header {
  box-shadow: none;
  -webkik-box-shadow: none;
}
.theme--light.v-stepper .v-stepper__header .v-divider  {
  &.active-step:before {
      content:"";
      width:12%;
      height:1px;
      position:absolute;
      background:#006BAF;
  }
  &.finished-step {
    border-color: #006BAF;
    border-width: 1px;
  }
}
#custom-multiple-email .notranslate.error--text {
  transform: none;
}
.v-stepper__header [data-tooltip]:hover:before {
  position : absolute;
  top: 50px;
  content: attr(data-tooltip);
}
.v-stepper__header .v-stepper__step--inactive:not(.v-stepper__step--complete):hover:before  {
  position : absolute;
  top: 50px;
  color:grey;
  content: attr(data-tooltip);
}
}
.custom-radio.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0px !important;
}
  #custom-table {
    td {
      font-size: 16px !important;
    }
    th {
      font-size: 14px !important;
      font-weight: normal;
    }
    tr td:first-child + td {
      word-break: break-all;
    }
  }
.engagement-wrapper{
  position:relative;
  overflow-x: hidden;
  .v-treeview-node__label{
    flex: none !important;
  }
  .v-label--active{
    background: white;
    padding-right: 2px;
  }
  .v-treeview-node__children{
    font-size: 0.875rem !important;
    font-weight: 400;
    letter-spacing: 0.0178571429em !important;
    line-height: 1.25rem;
  }
}
  .set-width.v-text-field input {
    min-width: 10% !important;
  }
    .chip-header {
    font-size: 13px !important;
  }
    .v-chip:not(.v-chip--no-color)[chip-icon] .v-icon {
    color: #606060 !important;
}
 .custom-selectbox .v-input__slot{
    max-height:100px !important;
  }
  .custom-selectbox .v-select__selections{
    overflow: auto;
    max-height:90px !important;
  }
  .container-info {
  position: relative;
  .v-breadcrumbs__item--disabled{
    color:black !important;
    padding: 0px 2px;
      }
    a,.v-breadcrumbs__divider{
      color:#006BAF !important;
      padding: 0px 2px;}
    }
    .info-drawer {
      .v-tab{
      color: #424242 !important;
      &--active{
        color:#03B6FC!important;
      }
    }
   .theme--light.v-tabs-items{
      z-index: 1;
      }
  .strike-not-through {
    position: relative;
    text-align: center;
  }
  .strike-not-through :first-line {
    background-color: white;
  }
  .strike-not-through :before {
    position: absolute;
    z-index: -1;
    content: "";
    left: 0px;
    right: 0px;
    height: 1px;
    top: 50%;
    background-color: lightgrey;
  }
}
.v-breadcrumbs {
  &__item {
    color: #006BAF ;
    padding: 0px 2px;
    cursor: pointer;
  }
  a {
      text-decoration: underline !important;
  }
  &__divider {
    color: #006BAF !important ;
    padding: 0px 2px;
  }
  li:last-child {
    div {
    color:black !important;
    text-decoration: none !important;
    cursor:auto;
    }
  }
  li:nth-child(even) {
    padding: 0 2px !important;
  }
  li:nth-child(odd) {
    font-size: 14px;
  }
}
.list-frame {
  overflow-y: auto;
  max-height: calc(100vh - 400px);
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0px !important;
}
/**
 * Need to move this into global css seprate file,
 * when all .v-dialog custom style should be common
 */
.v-dialog {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

// Dial pad chatbot style START
/* Desktop and larger screen styles */
@media only screen and (min-width: 640px) {
    #kpd_chat[enabled="true"] {
        bottom: 0%;            /* Align chat at the bottom */
        height: 100%;           /* Full height */
        width: 480px;           /* Fixed width */
        transform: scale(1.0);  /* No scaling */
    }
    #kpd_chat[enabled="false"] {
        bottom: -640px;         /* Hide chat off-screen */
    }
}

/* Mobile and smaller screen styles */
@media only screen and (max-width: 640px) {
    #kpd_chat[enabled="true"] {
        bottom: 0px !important; /* Force chat to stick at the bottom */
    }
}
// Dial pad chatbot style END

</style>
